import { Component } from 'react';

/// Common controls
/// type: if control have different styles like in buttons "text"
/// fn: function for click, onchange
/// param: if there is param for function
/// value: value set on click

export default class NemCtrl extends Component {
  handleChange = event => {
    if ('fn' in this.props) {
      if ('param' in this.props && 'value' in this.props) this.props.fn(this.props.param, this.props.value);
      else if ('param' in this.props) this.props.fn(this.props.param);
      else if ('value' in this.props) this.props.fn(this.props.value);
      else this.props.fn();
    }
  };
  getStyle = () => {
    var style = {};
    if ('style' in this) {
      if ('type' in this.props && this.props.type in this.style && 'default' in this.style) {
        style = Object.assign({}, this.style.default, this.style[this.props.type]);
      } else if ('type' in this.props && this.props.type in this.style) style = this.style[this.props.type];
      else if ('default' in this.style) style = this.style.default;
      else style = this.style;
    }
    if ('style' in this.props) {
      style = Object.assign({}, style, this.props.style);
    }
    return style;
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/NemCtrl.js
 **/